import type { AppFeatureDefinition } from "@nasam/kernel";
import { createOperationsRoutes } from "./presentation/routes";

const MISSIONS_VIEW =
  "operations.mission_management.mission_management_list.view";

export const operationsFeature: AppFeatureDefinition = {
  id: "operations",
  version: "0.1.0",
  titleKey: "common:businessModules.operations",
  icon: "Briefcase",
  basePath: "/operations",
  requiredPermissions: [MISSIONS_VIEW],
  navigation: [
    {
      id: "operations",
      titleKey: "common:businessModules.operations",
      icon: "Briefcase",
      placement: "rail",
      order: 30,
      children: [
        {
          id: "operations-missions",
          titleKey: "operations:nav.missions",
          placement: "drawer",
          order: 10,
          path: "/operations/missions",
          requiredPermissions: [MISSIONS_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createOperationsRoutes({ context }),
  i18n: {
    namespace: "operations",
    load: {
      en: () => import("./i18n/en"),
      ar: () => import("./i18n/ar"),
    },
  },
  permissionCatalog: [
    {
      segment: "operations",
      labelKey: "operations:permissions.operations",
      children: [
        {
          segment: "mission_management",
          labelKey: "operations:permissions.missionManagement",
          children: [
            {
              segment: "mission_management_list",
              labelKey: "operations:permissions.missions",
              actions: [
                { id: "view", labelKey: "operations:actions.view" },
                { id: "create", labelKey: "operations:actions.create" },
                { id: "update", labelKey: "operations:actions.update" },
                { id: "delete", labelKey: "operations:actions.delete" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
